module.exports = __webpack_public_path__ + "static/media/Mush_Mozza-dt-en.fc5a03e4.jpg";